import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders }  from '@angular/common/http';
import { Router }     from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { API_BASE_URL }                   from '../../environments/environment';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import * as XLSX from 'xlsx';
import { BaseComponent } from '../base.component';
import { AddressPrintDialogComponent } from '../common/address-print-dialog/address-print-dialog.component';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

export interface Customer {
  nameBillingAddress1: string;
  nameBililngAddress2: string;
  address1: string;
  numberPhone: string;
}

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.less']
})
export class CustomersComponent extends BaseComponent implements OnInit {
// 得意先一覧テーブルのデータソース
public dataSource = new MatTableDataSource();

selection = new SelectionModel(true, []);

// エクスポート用全件データ
exportData = [];

nowLoading = true;

// 連打防止用のリクエストID
private latestRequestId = 0;

// ページネーターの設定（コンポーネント側でページングするための初期表示件数）
pageSize = 50;

filterNameBillingAddress = "";

filterNameBillingAddressKana = "";

@ViewChild(MatPaginator) paginator: MatPaginator;

@ViewChild('TABLE') table: ElementRef;

public headers = new HttpHeaders({
  "X-LoginAccessKey": localStorage.getItem("accessKey")
});

public columnDefs = [
  'select',
  'nameBillingAddress1',
  'nameBillingAddress2',
  'address1',
  'numberPhone'
];

constructor(private http: HttpClient, private router: Router, private ngZone: NgZone, private dialog: MatDialog) {
  super();
}

  ngOnInit() {}

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }
  
  /**
  * ページ読み込み後の初期化メソッド
  */
  ngAfterViewInit() {
    console.info("ngAfterViewInit()");
    this.dataSource.paginator = this.paginator; // ページングはコンポーネント（クライアント）側で行う
    this.getAgreements();
  }

  /**
  * セルクリック時のコールバック
  * @param event 選択された行オブジェクト
  */
  cellClicked(event) {
    this.router.navigate(['/customers/' + event.cdBillingAddress]);
  }

  /**
   * フィルター実行
   * 得意先名、カナで絞込みを行う
   */
  applyFilter() {
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.getAgreements();
  }

  /**
  * 契約中一覧を取得します
  */
  getAgreements() {
    const requestId = ++this.latestRequestId; // リクエストの通し番号
    this.nowLoading = true;
    console.info(this.filterNameBillingAddress + ", " + this.filterNameBillingAddressKana);

    this.http.get(
      API_BASE_URL + '/api/v1/billingAddresses'
              + '?filterNameBillingAddress=' + encodeURIComponent(this.filterNameBillingAddress)
              + '&filterNameBillingAddressKana=' + encodeURIComponent(this.filterNameBillingAddressKana),
      {headers: this.headers}
    )
    .subscribe(res => {
      if (requestId !== this.latestRequestId) {
        // このリクエストより新しいリクエストが発行されている場合は、結果を破棄する
        return;
      }
      this.dataSource.data = res as Customer[];

      this.adjustmentSelection();
      this.nowLoading = false;
    }, error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      this.nowLoading = false;
    });
  }

  /**
  * エクスポート用に契約中一覧を全件取得します
  */
  async getAllAgreements():Promise<boolean> {
    this.nowLoading = true;
    console.info(this.filterNameBillingAddress + ", " + this.filterNameBillingAddressKana);
    let success = true;
    await this.http.get(
      API_BASE_URL + '/api/v1/billingAddresses'
              + '/all'
              + '?filterNameBillingAddress=' + encodeURIComponent(this.filterNameBillingAddress)
              + '&filterNameBillingAddressKana=' + encodeURIComponent(this.filterNameBillingAddressKana),
      {headers: this.headers}
    )
    .toPromise().then(res => {
      this.exportData = res as [];
      // エクスポート用に生成
      let data = []
      for (let i = 0; i < this.exportData.length; i++) {
        const e = this.exportData[i]
        data.push({ '得意先名':  e.nameBillingAddress1, '支店名': e.nameBillingAddress2, '住所': e.address1, 'TEL': e.numberPhone})
      }
      this.exportData = data;
    }, error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      success = false;
    });
    this.nowLoading = false;
    return success;
  }

  /**
   * 全選択済み
   * @returns
   */
  isAllSelected() {
    for (const row of this.dataSource.data) {
      if (!this.selection.isSelected(row)) return false
    }
    return true;
  }

  /**
   * 全選択 クリック
   * @returns
   */
  masterToggle() {
    if (this.isAllSelected()) {
      this.clearSelection();
    } else {
      // 1件ずつselect()すると件数分だけ変更通知が発生するため、apply()でまとめて1回にする
      this.selection.select.apply(this.selection, this.dataSource.data);
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: PeriodicElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  /**
   * Selection 調整
   * 再抽出でdataSourceがさし変わった際、新たなデータでSelectionの中身を入れ替えする。
   */
  adjustmentSelection() {
    this.selection.selected.forEach(select => {
      if (select) {
        const newSelect = this.dataSource.data.find(row =>
          row['cdBillingAddress'] && select.cdBillingAddress && row['cdBillingAddress'] == select.cdBillingAddress);
        if (newSelect) {
          // 選択解除
          this.selection.toggle(select);
          // 新たなデータで選択
          this.selection.toggle(newSelect);
        }
      }
    });
  }

  /**
   * 選択行クリア
   * 表示している行の選択をクリアする。
   * 検索条件で表示対象外となっているデータの選択はクリアしない。
   */
  clearSelection() {
    const selectedRows = this.dataSource.data.filter(row => this.selection.isSelected(row));
    if (selectedRows.length) {
      this.selection.deselect.apply(this.selection, selectedRows);
    }
  }

  /**
   * エクスポートボタン
   */
  async downloadCsv() {
    const success = await this.getAllAgreements();
    if (!success) {
      return;
    }
    const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(this.exportData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    // ファイル名設定
    let fileName = '得意先一覧.xlsx';
    XLSX.writeFile(wb, fileName);
  }

  /**
   * 宛名印刷 ボタン
   */
  addressPrint() {
    const selectionCds = [];
    for (const select of this.selection.selected) {
      if (selectionCds.indexOf(select.cdBillingAddress) == -1) selectionCds.push(select.cdBillingAddress);
    }

    // サイズ指定ダイアログ
    this.dialog.open(AddressPrintDialogComponent, { data: { selection: selectionCds, url: '/api/v1/billingAddresses/address-pdf/' }})
      .afterClosed().subscribe(success => {
        if (success) {
          this.selection.clear();
        }
      });
  }
}
